import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { handlePaginatedParameters } from "../_helpers/handle-parameters";
import { optionsWithDefaultsPaginated } from "../_helpers/options-with-defaults";
import { PaginatedOptions, UseQueryOptionsNoKeyAndFn } from "../_types";
import {
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE,
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH,
  VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_OPERATION,
  type VehicleValuationPriceAdjustmentSearchBody,
  type VehicleValuationPriceAdjustmentSearchParameters,
  type VehicleValuationPriceAdjustmentSearchResponse,
} from "./vehicle-valuation-price-adjustment.types";

export function useVehicleValuationPriceAdjustmentSearchQuery({
  options,
  enabled,
  queryOptions,
}: {
  options?: PaginatedOptions<
    VehicleValuationPriceAdjustmentSearchParameters,
    VehicleValuationPriceAdjustmentSearchBody
  >;
  enabled?: boolean;
  queryOptions?: UseQueryOptionsNoKeyAndFn<
    VehicleValuationPriceAdjustmentSearchResponse,
    Error,
    VehicleValuationPriceAdjustmentSearchResponse,
    readonly unknown[]
  >;
} = {}) {
  const optionsWithDefaults =
    optionsWithDefaultsPaginated<
      PaginatedOptions<VehicleValuationPriceAdjustmentSearchParameters, VehicleValuationPriceAdjustmentSearchBody>
    >(options);
  const params = handlePaginatedParameters(optionsWithDefaults.parameters);
  const body = optionsWithDefaults.body;

  return useQuery({
    queryKey: [
      VEHICLE_VALUATION_PRICE_ADJUSTMENT_RESOURCE,
      VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_OPERATION,
      { params, body },
    ],
    queryFn: async () => {
      const response = await alphartisApiAxios.post<VehicleValuationPriceAdjustmentSearchResponse>(
        VEHICLE_VALUATION_PRICE_ADJUSTMENT_SEARCH_API_PATH,
        body,
        {
          params,
        },
      );

      return response.data;
    },
    ...queryOptions,
    enabled,
  });
}
